import type { usePassengers } from '@aviata/booking-composable';
import type { createPassengersData, PassengerKey } from '@aviata/booking-data';
import type { Airflow } from '@aviata/platform-types';

/**
 * Run the schema-driven passenger init that PassengersDataPage and
 * QuickBookingPage both used to inline. Reads the passenger keys from
 * the schema record, hydrates `passengersData` storage, and seeds the
 * `usePassengers` composable so the form has typed state to bind to.
 * Caller decides what to do when the schema is missing — pass the
 * inner `.passengers.schema` record (the `Airflow.Offer.Schema.Passengers`
 * keyed map), not the wrapper.
 */
export const initPassengersFromSchema = (
  schema: Airflow.Offer.Schema.Passengers,
  passengers: ReturnType<typeof usePassengers>,
  passengersData: ReturnType<typeof createPassengersData>,
) => {
  const passengersKeys = Object.keys(schema) as PassengerKey[];
  const { passengers: initialPassengers, passengersKeys: sortedKeys } =
    passengersData.init(passengersKeys);
  passengers.init({
    keys: sortedKeys,
    initialState: initialPassengers,
    schema,
  });
};
